import React from "react";
import ManageBankInfo from "./ManageBankInfo";
import { statusStyles } from "../../../Utility";
function CardAccount({ updateDefaultAccount, handleDelete, selected, item, oldDefaultAccount, setVerifyAccount }) {
  const status = item?.status !== "pending_manual_verification" ? "Verified" : "Unverified";
  return (
    <div className="block col-xl-4 col-md-6">
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between mb-3">
            <span>
              <img
                src={item?.bankLogo}
                style={{ height: "60px", width: "60px", borderRadius: "50%" }}
                alt=""
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = require("../../../assets/images/icon-bank-black.svg").default;
                }}
                className="d-none d-md-block"
              />
              <span className="bank-name"> {item?.nick_name}</span>
              {selected === "Default" && <span className={`${statusStyles("Default")?.styles} mx-4`}>{selected}</span>}
              <span
                className={`${statusStyles(status)?.styles} ${selected === "Default" ? "" : "mx-4"}`}
                style={{ height: "35px" }}
              >
                {statusStyles(status)?.text}
              </span>
            </span>
            <div className="dropdown">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src={require("../../../assets/images/toggle-btn.svg").default} alt="" />
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                {status === "Unverified" && (
                  <li className="dropdown-item" onClick={() => setVerifyAccount(item)}>
                    <img
                      style={{ maxHeight: "12px" }}
                      src={require("../../../assets/images/icon-check-green.svg").default}
                    />
                    <span className={`text-success`}>Verify</span>
                  </li>
                )}

                <ManageBankInfo
                  selected={selected}
                  updateDefaultAccount={updateDefaultAccount}
                  item={item}
                  oldDefaultAccount={oldDefaultAccount}
                />

                <li className="dropdown-item" onClick={() => handleDelete(item)}>
                  <img src={require("../../../assets/images/delete.svg").default} />
                  <span className={`text-danger`}>Delete</span>
                </li>
              </ul>
            </div>
          </div>
          <ul className="list-unstyled bank-details mb-0">
            <li>
              Bank Name <span>{item?.bank_name}</span>
            </li>
            <li>
              Routing Number <span>{`XXXXX` + item?.routing_number?.substring(item?.routing_number?.length - 4)}</span>
            </li>
            <li>
              Account Number <span>{`XXXXXX` + item?.account_number}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CardAccount;
